import {computed, inject, Injectable, signal} from '@angular/core';
import {BreakpointObserver} from "@angular/cdk/layout";

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService {
  private static readonly MOBILE_MAX_WIDTH = 768;
  private breakpointObserver = inject(BreakpointObserver)
  private _isMobile = signal(false)
  private _isBelow500 = signal(false)
  private _isBelow600 = signal(false)
  private _isBelow1200 = signal(false)
  private _isBelow1000 = signal(false)

  public readonly isMobile = computed(() => this._isMobile());
  public readonly isBelow500 = computed(() => this._isBelow500());
  public readonly isBelow600 = computed(() => this._isBelow600());
  public readonly isBelow1000 = computed(() => this._isBelow1000());
  public readonly isBelow1200 = computed(() => this._isBelow1200());

  constructor() {
    this.breakpointObserver
      .observe([
        `(max-width: ${ScreenSizeService.MOBILE_MAX_WIDTH}px)`,
        '(max-width: 499px)',
        '(max-width: 599px)',
        '(max-width: 999px)',
        '(max-width: 1199px)'
      ])
      .subscribe((result) => {
        this._isMobile.set(result.breakpoints[`(max-width: ${ScreenSizeService.MOBILE_MAX_WIDTH}px)`]);
        this._isBelow500.set(result.breakpoints['(max-width: 499px)']);
        this._isBelow600.set(result.breakpoints['(max-width: 599px)']);
        this._isBelow1000.set(result.breakpoints['(max-width: 999px)']);
        this._isBelow1200.set(result.breakpoints['(max-width: 1199px)']);
      });
  }
}
